import axios from 'axios'
import { api } from '../util/api'
export default {
	regWxConfig(sdkConfigData) {
		return new Promise((resolve, reject) => {
			try {
				let config = {
					debug: false,
					jsApiList: ['checkJsApi', 'openLocation']
				}
				
		
				config.appId = sdkConfigData.AppId
				config.timestamp = sdkConfigData.TimeStamp
				config.nonceStr = sdkConfigData.NonceStr
				config.signature = sdkConfigData.Signature
				
				wx.config(config)
		
				wx.error( res => {
					console.dir('注册Config失败：' + res.errMsg)
					reject(res)
				})
				
				wx.ready(() => {
					wx.checkJsApi && wx.checkJsApi({
						jsApiList: config.jsApiList,
						success: res => {
							let key, ret
							ret = /ok$/.test(res.errMsg)
							if (!ret) {
								reject()
								return
							} else {
							}
							for (key in res.checkResult) {
								if(!res.checkResult[key]) {
									reject()
								}
							}
							resolve()
						},
						fail: err => {
							console.dir(err)
							reject(err)
						}
					})
				})
			} catch (err) {
				console.dir(err)
				reject(err)
			}
		})
	},
	async init() {
		try {
            let res = await axios.get(api.GetWxConfig, {
                params: {
                    openUrl: window.location.href.split('#')[0]
                }
            })
            if (res && res.data && res.data.IsSucess) {
               	let as = await this.regWxConfig(res.data.Body)
            	return Promise.resolve()
            } else {
                return Promise.reject()
            }
        } catch (error) {
            return Promise.reject()
        }
    }
}



// WEBPACK FOOTER //
// ./src/util/wxConfig.js